<template>
	<CModal
		:show.sync="isShow"
		:close-on-backdrop="false"
		centered
		class="modal-condition"
	>
		<template #header-wrapper>
			<ModalHeaderWrapper
				:title="title"
				@onClose="handleCancel"
			/>
		</template>
		<template #default>
			<CRow
				:gutters="false"
				align-horizontal="between"
			>
				<CCol lg="12" class="mb-4">
					<CRow class="d-flex align-items-center">
						<CCol class="typo-label">
							{{ $t('message.quantity_lower_than') }}
						</CCol>
						<CCol class="mr-0">
							<BaseInputNumber
								v-model="form.minQty"
								:append-text="$t('message.qty')"
								:disabled="disabled"
								text-align="left"
								class="w-120px ml-auto"
							/>
						</CCol>
					</CRow>
				</CCol>
				<CCol lg="12" class="mb-3">
					<CRow class="d-flex align-items-center">
						<CCol class="typo-label">
							{{ $t('message.stock_will_allocate_to_channel') }}
						</CCol>
					</CRow>
				</CCol>
				<CCol lg="12">
					<CRow
						v-for="(item, index) in form.channels"
						:key="index"
						class="mb-3"
					>
						<CCol class="col-6 d-flex align-items-center">
							<span class="typo-body-2">
								{{ item.name }}
							</span>
						</CCol>
						<CCol class="col-6">
							<BaseInputNumber
								v-model="item.qty"
								:append-text="$t('message.qty')"
								:disabled="disabled"
								text-align="left"
								class="w-120px ml-auto"
							/>
						</CCol>
					</CRow>
				</CCol>
			</CRow>
		</template>
		<template #footer>
			<BaseModalFooter
				:disabled-comfirm="disabled"
				:disabled-cancel="false"
				:is-show-total="false"
				:is-show-clear="!disabled"
				@onCancel="handleCancel"
				@onConfirm="handleSubmit"
				@onClear="handleClear"
			/>
		</template>
	</CModal>
</template>

<script>
import { cloneDeep } from '../helpers/utils';

export default {
	props: {
		title: {
			type: String,
			default: null,
		},
		minQty: {
			type: [Number, String],
			default: 0,
		},
		channels: {
			type: Array,
			default: () => [],
		},
		disabled: {
			type: Boolean,
			default: false,
		},
	},

	data() {
		return {
			isShow: false,
			form: {
				minQty: 0,
				channels: [],
			},
		};
	},

	watch: {
		minQty() {
			this.form.minQty = cloneDeep(this.minQty);
		},
		channels() {
			this.form.channels = cloneDeep(this.channels);
		},
		isShow() {
			if (this.isShow) {
				this.form.minQty = cloneDeep(this.minQty);
				this.form.channels = cloneDeep(this.channels);
			}
		},
	},

	created() {
		this.form.minQty = cloneDeep(this.minQty);
		this.form.channels = cloneDeep(this.channels);
	},

	methods: {
		open() {
			this.isShow = true;
		},
		close() {
			this.isShow = false;
		},
		handleSubmit() {
			this.$emit('onSubmit', this.form);
			this.close();
		},
		handleCancel() {
			this.$emit('onCancel');
			this.close();
		},
		handleClear() {
			this.form.minQty = 0;
			this.form.channels.forEach((item, index) => {
				this.form.channels[index].qty = 0;
			});
		},
	},
};
</script>

<style lang="scss" scoped>
::v-deep .modal-dialog {
	max-width: rem(500);
}
</style>
